import { render } from "./TrasladosAprobar.vue?vue&type=template&id=0c9ae06e"
import script from "./TrasladosAprobar.vue?vue&type=script&lang=js"
export * from "./TrasladosAprobar.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.29_vue@3.5.29_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__